(ns com.theplantscape.plant-web.api.user
  (:require [com.theplantscape.plant-web.draw.api :as api]
            [com.theplantscape.plant-web.api.core :refer [sync]]
            [clojure.core.async :refer [go chan <! >! pub sub go-loop]]

            [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]
            [com.theplantscape.plant-web.draw.state :refer [site-state]]))

(defn fetch-webauth-challenge [mode cb]
  (api/make-request
   {:method :get
    :uri (api-url-build "/api/v2/auth/webauth/start?mode=" mode)
    :headers {:authorization (-> @site-state :auth :access_token)}}
   cb))

(defn add-new-plant [values]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/plant/add")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params values}
    #(prn "ajax add plant")))

(defn fetch-diagrams [cb]
  (api/make-request
   {:method :get
    :uri (api-url-build "/api/v2/diagram/user")
    :headers {:authorization (-> @site-state :auth :access_token)}}
   cb
    #_(prn "ajax fetch diagram")))

(defn share-diagram [values]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/diagram/share")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params {:svg  values}}
    #(prn "ajax share diagram")))

(defn store-diagram [values]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/diagram/save")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params {:svg  values}}
    #(prn "ajax add diagram")))

(defn api-register-user [values]
  (api/make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/auth/register")
    :params values}))

(defn api-user-request-reset-password [values]
  (api/make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/auth/request/reset")
    :params values}))

(defn api-user-reset-password [values]
  (api/make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/auth/reset")
    :params values}))

(defn api-login2 [values]
  (api/make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/auth/login")
    :params values}))

(defn api-login [values cb]
  (api/make-request
   {:method :post
    :uri (api-url-build "/api/v2/auth/login")
    :params values}
   cb))

(defn api-fetch-user-proile []
  (api/make-request-async
   {:method :get
    :headers {:authorization (-> @site-state :auth :access_token)}
    :uri (api-url-build "/api/v2/auth/profile")}))

(defn api-update-user-proile [user]
  (api/make-request-async
   {:method :post
    :headers {:authorization (-> @site-state :auth :access_token)}
    :uri (api-url-build "/api/v2/auth/profile/update")
    :params user}))

(comment 
  (fetch-diagrams
   #(swap! site-state assoc-in [:user :diagrams] %))
  
  (api-login2 {:username "@user:matrix.org"
               :password "error"} prn)
  (api-login2 {} prn)
  (go (-> (sync api/make-request {:method :get
    :uri (api-url-build "/api/v2/diagram/user")
                                  :headers {:authorization (-> @site-state :auth :access_token)}} <!)
          ))
  )
